import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail, Instagram, ArrowRight } from 'lucide-react';
export function CTASection() {
  return <section id="contacto" className="py-32 md:py-40 px-6 md:px-12 lg:px-24 bg-rose-blush" data-id="element-31">
      <div className="max-w-6xl mx-auto" data-id="element-32">
        {/* Eyebrow & Divider */}
        <div className="mb-16" data-id="element-33">
          <span className="text-xs font-sans uppercase tracking-[0.3em] text-charcoal/60 block mb-4" data-id="element-34">
            — CONTACTO
          </span>
          <div className="w-full h-[1px] bg-charcoal/10" data-id="element-35" />
        </div>

        {/* Main Image Card */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 1
      }} className="relative w-full h-[350px] md:h-[450px] rounded-2xl overflow-hidden mb-20 shadow-sm border border-charcoal/5" data-id="element-36">
          <div className="absolute inset-0 bg-charcoal/40 mix-blend-multiply z-10" data-id="element-37" />
          <img src="https://images.unsplash.com/photo-1449034446853-66c86144b0ad?q=80&w=2000&auto=format&fit=crop" alt="View from car" className="w-full h-full object-cover" data-id="element-38" />
          <div className="absolute inset-0 z-20 flex flex-col items-center justify-center text-center p-6" data-id="element-39">
            <h2 className="text-4xl md:text-5xl lg:text-7xl font-serif italic text-white mb-6 leading-[1.1]" data-id="element-40">
              Elige tu{' '}
              <span className="font-bold" data-id="element-41">
                próximo
                <br data-id="element-42" />
                destino
              </span>
            </h2>
            <p className="text-sm md:text-lg font-sans font-light text-white/90 max-w-md" data-id="element-43">
              Escríbenos y te enviamos toda la información para tu próxima
              aventura.
            </p>
          </div>
        </motion.div>

        {/* Contact Info Columns */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 text-charcoal font-sans" data-id="element-44">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="flex flex-col items-start" data-id="element-45">
            <div className="w-10 h-10 rounded-full border border-rose-primary/30 flex items-center justify-center mb-6 text-rose-primary" data-id="element-46">
              <Phone className="w-4 h-4" data-id="element-47" />
            </div>
            <h3 className="text-xs uppercase tracking-[0.2em] text-charcoal/50 mb-2" data-id="element-48">
              WhatsApp
            </h3>
            <p className="text-lg font-serif italic" data-id="element-49">+569 1234 5678</p>
            <a href="#" className="mt-4 text-xs font-medium uppercase tracking-wider text-rose-primary flex items-center gap-1 hover:text-rose-light transition-colors" data-id="element-50">
              Enviar mensaje <ArrowRight className="w-3 h-3" data-id="element-51" />
            </a>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.3
        }} className="flex flex-col items-start" data-id="element-52">
            <div className="w-10 h-10 rounded-full border border-rose-primary/30 flex items-center justify-center mb-6 text-rose-primary" data-id="element-53">
              <Mail className="w-4 h-4" data-id="element-54" />
            </div>
            <h3 className="text-xs uppercase tracking-[0.2em] text-charcoal/50 mb-2" data-id="element-55">
              Email
            </h3>
            <p className="text-lg font-serif italic" data-id="element-56">hola@aventuras.com</p>
            <a href="#" className="mt-4 text-xs font-medium uppercase tracking-wider text-rose-primary flex items-center gap-1 hover:text-rose-light transition-colors" data-id="element-57">
              Escribir correo <ArrowRight className="w-3 h-3" data-id="element-58" />
            </a>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} className="flex flex-col items-start" data-id="element-59">
            <div className="w-10 h-10 rounded-full border border-rose-primary/30 flex items-center justify-center mb-6 text-rose-primary" data-id="element-60">
              <Instagram className="w-4 h-4" data-id="element-61" />
            </div>
            <h3 className="text-xs uppercase tracking-[0.2em] text-charcoal/50 mb-2" data-id="element-62">
              Síguenos
            </h3>
            <p className="text-lg font-serif italic" data-id="element-63">@aventurasporelmundo</p>
            <a href="#" className="mt-4 text-xs font-medium uppercase tracking-wider text-rose-primary flex items-center gap-1 hover:text-rose-light transition-colors" data-id="element-64">
              Ver perfil <ArrowRight className="w-3 h-3" data-id="element-65" />
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}